import { type ActivitiesType } from '@data/activities/activities';

export const getActivitiesByLeadUuid = `
query leadActivitiesContent(
  $leadUuid: String,
  $activityIds: [Int!],
  $limit: Int,
  $cursor: String,
  $timeFilter: TimeFilterInput,
  $activitySubtypes: [ID!]
) {
  leadActivities(
    leadUuid: $leadUuid,
    limit: $limit,
    cursor: $cursor,
    activityIds: $activityIds,
    timeFilter: $timeFilter,
    activitySubtypes: $activitySubtypes
  ) {
    leadActivities {
      leadActivityUuid
      activityNote
      activityTime
      createdAt
      owner {
        userUuid
        firstName
        lastName
        email
      }
      createdBy {
        userUuid
        firstName
        lastName
        email
      }
      activity {
        id
        displayName
        description
        score
        activityType
        status
        noteRenderType
        allowDeletion
        lockActivity
      }
    }
    pageInfo {
      hasNextPage
      endCursor
    }
  }
}
`;

export type NoteRenderType = 'textarea' | 'html';

export interface ActivityType {
  id: string;
  displayName: string;
  description: string;
  score: number;
  activityType: Omit<ActivitiesType, 'all'>;
  status: string;
  noteRenderType: NoteRenderType;
  allowDeletion: boolean;
  lockActivity: boolean;
}

export interface UserType {
  userUuid: string;
  firstName: string;
  lastName: string;
  email: string;
}

export interface LeadActivityType {
  leadActivityUuid: string;
  activityNote: string;
  activityTime: string;
  owner: UserType;
  createdBy: UserType;
  activity: ActivityType;
  createdAt: string;
}

export interface PageInfoType {
  hasNextPage: boolean;
  endCursor?: string;
}

export interface GetActivitiesByLeadUuidResponse {
  leadActivities: {
    leadActivities: LeadActivityType[];
    pageInfo: PageInfoType;
  }
}
